import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndo = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 17,
	viewBox: "0 0 15 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.42698 2.80614C3.85268 1.63736 5.62094 1.15591 7.23689 1.15591C11.5243 1.15591 15 4.63157 15 8.91902C15 13.2065 11.5243 16.6821 7.23689 16.6821C5.01685 16.6821 3.0131 15.7489 1.59954 14.2563L1.45526 14.1039L2.97866 12.6612L3.12293 12.8136C4.15675 13.9052 5.61668 14.584 7.23689 14.584C10.3656 14.584 12.9019 12.0477 12.9019 8.91902C12.9019 5.79034 10.3656 3.25405 7.23689 3.25405C5.97682 3.25405 4.68067 3.63571 3.67448 4.50021L6.46078 4.75771L6.26771 6.84694L0 6.26771L0.579234 0L2.66847 0.193078L2.42698 2.80614Z",
		fill: "currentColor"
	})]
});
export default SvgUndo;
